// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"b3e46d94","719":"d6d64ac8","955":"e630fbe7"}[chunkId] + ".chunk.css";
};